import {Component, ViewChild} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../state/app.state";
import {ActivatedRoute, Router} from "@angular/router";
import {drillDownUrls, screenSize} from "../../../shared/core/shared.selectors";
import {SetDrillDownUrls} from "../../../shared/core/shared.actions";
import {dashboardFilter} from "../core/clients-list.selectors";
import {
  FetchClientsListRequest,
  FetchDashboardFilterRequest
} from "../core/clients-list.actions";
import * as Validation from "../../../shared/constants/validation.constants";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {
  TableHostDirective
} from "../../../shared/directive/table-host.directive";
import {
  FilterHostDirective
} from "../../../shared/directive/filter-host.directive";
import {DropdownOption} from "../../../../models/dropdown-option.model";
import {
  ClinicInformationTableComponent
} from "../components/tables/clinic-information-table/clinic-information-table.component";
import {
  ClinicInformationFilterComponent
} from "../components/filters/clinic-information-filter/clinic-information-filter.component";
import {
  GroupInformationTableComponent
} from "../components/tables/group-information-table/group-information-table.component";
import {
  GroupInformationFilterComponent
} from "../components/filters/group-information-filter/group-information-filter.component";
import {
  ParticipantOrCaregiverInformationTableComponent
} from "../components/tables/participant-or-caregiver-information-table/participant-or-caregiver-information-table.component";
import {
  ParticipantOrCaregiverInformationFilterComponent
} from "../components/filters/participant-or-caregiver-information-filter/participant-or-caregiver-information-filter.component";
import {
  ParticipantWeightInformationTableComponent
} from "../components/tables/participant-weight-information-table/participant-weight-information-table.component";
import {
  ParticipantWeightInformationFilterComponent
} from "../components/filters/participant-weight-information-filter/participant-weight-information-filter.component";
import {
  ParticipantBehaviourInformationTableComponent
} from "../components/tables/participant-behaviour-information-table/participant-behaviour-information-table.component";
import {
  ParticipantBehaviourInformationFilterComponent
} from "../components/filters/participant-beahaviour-information-filter/participant-behaviour-information-filter.component";
import {
  MeasurementInformationTableComponent
} from "../components/tables/measurement-information-table/measurement-information-table.component";
import {
  MeasurementInformationFilterComponent
} from "../components/filters/measurment-information-filter/measurement-information-filter.component";
import {CommonService} from "../../../shared/services/common.service";
import {ClientListService} from '../services/client-list.service';


@Component({
  selector: 'app-clients-list-screen',
  templateUrl: './clients-list-screen.component.html',
  styleUrls: ['./clients-list-screen.component.css']
})
export class ClientsListScreenComponent {
  @ViewChild(TableHostDirective, {static: true}) tableHost!: TableHostDirective;
  @ViewChild(FilterHostDirective, {static: true}) filterHost!: FilterHostDirective;
  tableComponent: any;
  filterComponent: any;
  selectedDashboard: any;
  expandPanel: any;
  addClinicButtonName: any;
  addMeasurementButtonName: any;
  loading: boolean = false;
  clientsList = [];
  dashboardFilterList: DropdownOption[] = [];
  validation = Validation;
  errorMessages: any = {};
  errorMessageMap = {
    'dashboard': {
      required: 'This field is required.'
    }
  }
  heading = '';
  dashboardMap = {
    1: {
      tableComponent: ClinicInformationTableComponent,
      filterComponent: ClinicInformationFilterComponent,
      heading: 'Organization Information'
    },
    2: {
      tableComponent: GroupInformationTableComponent,
      filterComponent: GroupInformationFilterComponent,
      heading: 'Group Information'
    },
    3: {
      tableComponent: ParticipantOrCaregiverInformationTableComponent,
      filterComponent: ParticipantOrCaregiverInformationFilterComponent,
      heading: ' Participant/Adult Information'
    },
    4: {
      tableComponent: ParticipantWeightInformationTableComponent,
      filterComponent: ParticipantWeightInformationFilterComponent,
      heading: 'Participant Weight Information'
    },
    5: {
      tableComponent: ParticipantBehaviourInformationTableComponent,
      filterComponent: ParticipantBehaviourInformationFilterComponent,
      heading: 'Participant Behavior Information'
    },
    6: {
      tableComponent: MeasurementInformationTableComponent,
      filterComponent: MeasurementInformationFilterComponent,
      heading: 'Measurement Information'
    },
  }
  form = new FormGroup({
    dashboard: new FormControl({value: null, disabled: false}, [Validators.required]),
  })
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private clientListService: ClientListService,
  ) {
    this.store.dispatch(FetchClientsListRequest());
    this.store.dispatch(FetchDashboardFilterRequest());
  }

  ngOnInit() {
    this.store.select(dashboardFilter)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.loading = data.loading;
        this.dashboardFilterList = data?.list;
      });

    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        let dashboardId = qp['dashboardId'];
        if (dashboardId) {
          dashboardId = Number(dashboardId);

          const isValid = !!this.dashboardFilterList.find(o => o.key == dashboardId);

          if (isValid) {
            this.form.patchValue({
              dashboard: dashboardId
            });

            this.selectedDashboard = dashboardId;
            this.expandPanel = true;

            this.tableComponent = this.dashboardMap[this.selectedDashboard].tableComponent;
            this.filterComponent = this.dashboardMap[this.selectedDashboard].filterComponent;
            this.heading = this.dashboardMap[this.selectedDashboard].heading;

            this.loadFilterComponent();
            this.loadTableComponent();
          } else {
            this.router.navigate([], {
              queryParams: {
                dashboardId: this.dashboardFilterList[0]?.key || -1
              }
            })
          }

        } else {
          this.router.navigate([], {
            queryParams: {
              dashboardId: this.dashboardFilterList[0]?.key || -1
            }
          })
        }
      })


    this.form.controls['dashboard']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.router.navigate([], {
          queryParams: {
            dashboardId: data
          }
        });
      });

    const selectedOption = +this.route.snapshot.queryParamMap.get('select');
    if (selectedOption) {
      this.form.controls.dashboard.patchValue(selectedOption);
    }

    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();
        
        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });

    this.store.select(screenSize).pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data == 'xs' || data == 'sm') {
          this.addClinicButtonName = 'Add';
          this.addMeasurementButtonName = 'Add';
        } else {
          this.addClinicButtonName = 'Add Organization';
          this.addMeasurementButtonName = 'Add Measurement'
        }
      });
  }

  checkForErrors(currentField ?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  loadTableComponent() {
    // get container reference
    const viewContainerRef = this.tableHost.viewContainerRef;
    viewContainerRef.clear();

    // create setting component
    viewContainerRef.createComponent(
      this.tableComponent
    ).location.nativeElement.classList.add('table-component');

  }

  loadFilterComponent() {
    // get container reference
    const viewContainerRef = this.filterHost.viewContainerRef;
    viewContainerRef.clear();

    // create setting component
    viewContainerRef.createComponent(
      this.filterComponent
    ).location.nativeElement.classList.add('filter-component');

  }

  selectClient(client) {
    this.store.select(drillDownUrls).subscribe(data => {
      const updatedDrilldownUrls = [...data, this.router.url];
      if ([...data].pop() !== this.router.url) {
        this.store.dispatch(SetDrillDownUrls({payload: updatedDrilldownUrls}));
      }

      const urlPrefix = this.router.url.split('/')[1];

      this.router.navigate([`/${urlPrefix}/organization/${client.id}`]);
    }).unsubscribe();
  }

  selectClientAdmin(clientAdmin) {
    this.store.select(drillDownUrls).subscribe(data => {
      const updatedDrilldownUrls = [...data, this.router.url];
      if ([...data].pop() !== this.router.url) {
        this.store.dispatch(SetDrillDownUrls({payload: updatedDrilldownUrls}));
      }

      const urlPrefix = this.router.url.split('/')[1];

      this.router.navigate([`/${urlPrefix}/organization-admin/${clientAdmin.id}`]);
    }).unsubscribe();
  }

  onAddClinic() {
    const urlPrefix = this.router.url.split('/')[1];
    this.router.navigate([`/${urlPrefix}/organization/add`]);
  }

  onAddGroup() {
    const urlPrefix = this.router.url.split('/')[1];
    this.router.navigate([`/${urlPrefix}/group/create`]);
  }

  onAddMeasurement(event: MouseEvent) {
    event.stopPropagation();
    this.clientListService.onAddMeasurementClick.next();
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
